import { ShortURL } from 'src/admin-entity/interface/etc/short-url.interface';
import { Page } from 'src/admin-entity/interface/page/page-info.interface';

export interface ETCInitialState {
    shortURLList: Page<ShortURL>;
    page: number;
    take: number;
}

export const initialState: ETCInitialState = {
    shortURLList: {
        list: [],
        page: {
            count: 0,
            nextPage: 0,
        },
    },
    page: 0,
    take: 30,
};
